export default function initPlaintextPasswordToggle() {
  document.querySelectorAll("[data-toggle-password]").forEach(function (item) {
    const field = document.getElementById(
      item.attributes["data-toggle-password"].value
    );
    item.addEventListener("click", () => {
      field.type = field.type === "password" ? "text" : "password";
    });
  });
}
